import { useEffect, useState } from 'react';

interface ExpirationProgress {
  progressValue: number;
  timeRemaining: string;
  isExpired: boolean;
}

export function useExpirationProgress(expirationDate?: string): ExpirationProgress {
  const [state, setState] = useState<ExpirationProgress>(() =>
    calculateProgress(expirationDate)
  );

  useEffect(() => {
    if (!expirationDate) return;

    setState(calculateProgress(expirationDate));

    const interval = setInterval(() => {
      setState(calculateProgress(expirationDate));
    }, 1000);

    return () => clearInterval(interval);
  }, [expirationDate]);

  return state;
}

function calculateProgress(expirationDate?: string): ExpirationProgress {
  if (!expirationDate) {
    return {
      progressValue: 0,
      timeRemaining: '—',
      isExpired: false,
    };
  }

  const now = new Date().getTime();
  const expiration = new Date(expirationDate).getTime();
  const timeRemaining = expiration - now;

  if (timeRemaining <= 0) {
    return {
      progressValue: 100,
      timeRemaining: 'Expirado',
      isExpired: true,
    };
  }

  const hours = Math.floor(timeRemaining / (1000 * 60 * 60));
  const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

  let formattedTime = '';
  if (hours > 0) {
    formattedTime = `${hours}h ${minutes}m`;
  } else if (minutes > 0) {
    formattedTime = `${minutes}m ${seconds}s`;
  } else {
    formattedTime = `${seconds}s`;
  }

  const hoursRemaining = timeRemaining / (1000 * 60 * 60);
  const progressValue = Math.max(0, Math.min(100, 100 - Math.round((hoursRemaining / 72) * 100)));

  return {
    progressValue,
    timeRemaining: formattedTime,
    isExpired: false,
  };
}
